export enum MachineServiceCardUnit {
  UNIT = 'unit',
  LITER = 'liter',
  KG = 'kg'
}
